
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const useGroupActions = () => {
  const navigate = useNavigate();
  
  const handleAddGroup = useCallback(() => {
    navigate('/groups');
  }, [navigate]);
  
  const handleTrackGroupUsage = useCallback((groupId: string) => {
    navigate(`/groups/${groupId}/usage`);
  }, [navigate]);
  
  return {
    handleAddGroup,
    handleTrackGroupUsage
  };
};
